export default {
    "en-US": {
        translation: {
            "signIn" : "Sign In with SSO",
            "transactionHub" : "Transaction Hub",
            "shell" : "Shell",
            "enabled" : "Enabled",
            "disabled" : "Disabled",
            "shellAviationAIMS" : "Shell Aviation AIMS"
        }
    }
}
